import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const getBrandStatsByGroup = async (groupId, startDate = null, endDate = null) => {
  if (!groupId) {
    console.error('Group ID no proporcionado');
    return [];
  }

  try {
    const getStatsFn = httpsCallable(functions, 'getBrandStatsByGroupV2');
    const result = await getStatsFn({
      groupId,
      requestedApp: 'group_web',
      startDate: startDate instanceof Date ? startDate.getTime() : null,
      endDate: endDate instanceof Date ? endDate.getTime() : null,
    });

    if (Array.isArray(result.data)) {
      return result.data;
    }
    if (result.data && result.data.success === 'yes') {
      return result.data.data || [];
    }
    return [];
  } catch (error) {
    console.error('Error obteniendo estadísticas de marcas:', error);
    notifyPermissionDenied(error);
    return [];
  }
};
